import { Observable } from 'rxjs';
import { startSubmit, stopSubmit, initialize } from 'redux-form/immutable';
import { formatInTimeZone } from 'date-fns-tz';
import { convertTokens } from '@date-fns/upgrade/v2';

import DeedsApi from 'entities/deed/api';
import { showMessageAction, showErrorAction } from 'containers/Notification/actions';

import { toggleEmailAttendeesOverlayAction } from '../actions';

import { INIT, SEND, FORM_IDENTIFIER } from './constants';
import { sendSuccessAction, sendFailedAction } from './actions';

const prefilledFormValues = (deed) => ({
  subject: `Important Info: “${deed.name} ${
    deed.startingAt
      ? formatInTimeZone(deed.startingAt, deed.timeZone, convertTokens('dddd MMMM DD, h:mm A'))
      : ''
  }”`.trim(),
  message: `Hi {{VOLUNTEER_NAME}},<br /><br/><br /><br />Thank you,<br />${
    deed.organization?.name ||
    deed?.nonprofits?.map((nonprofit) => nonprofit.get('name'))?.join(', ')
  }`,
  fromName:
    deed.organization?.name ||
    deed?.nonprofits?.map((nonprofit) => nonprofit.get('name'))?.join(', '),
  fromEmail: deed && deed.organizerEmail,
});

const init = (action$) =>
  action$
    .ofType(INIT)
    .mergeMap(({ deed }) => Observable.of(initialize(FORM_IDENTIFIER, prefilledFormValues(deed))));

const send = (action$) =>
  action$.ofType(SEND).mergeMap(({ deed, subject, message, fromName, fromEmail }) =>
    Observable.concat(
      Observable.of(startSubmit(FORM_IDENTIFIER)),
      DeedsApi.emailAttendees(deed.id, subject, message, fromName, fromEmail)
        .mergeMap(() => [
          showMessageAction('Attendees Emailed.'),
          sendSuccessAction(),
          stopSubmit(FORM_IDENTIFIER),
          initialize(FORM_IDENTIFIER, prefilledFormValues(deed)),
          toggleEmailAttendeesOverlayAction(false),
        ])
        .catch((e) => [
          sendFailedAction(e),
          stopSubmit(FORM_IDENTIFIER),
          showErrorAction('Emailing Attendees Failed.'),
        ])
    )
  );

export default [init, send];
